import { Component } from '@angular/core';
import { HomeworkService } from '../../../../services/homework.service';
import { ApplicationStateService } from '../../../../services/application-state.service';

@Component({
    selector: 'sidebar-portfolio',
    templateUrl: './portfolio.component.html',
    styleUrls: ['./portfolio.component.scss'],
    standalone: true
})
export class PortfolioComponent {

    constructor(public homeworkService: HomeworkService,
                public applicationStateService: ApplicationStateService) {
    }

    openPortfolio(): void {
        window.open(this.homeworkService.portfolioLink, '_blank');
    }
}
